import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const handleLangChange = (e) => {
        i18n.changeLanguage(e.target.value);
    };

    return (
        <div className="flex items-center dark:bg-white/20 rounded-full px-3 py-1 text-sm shadow backdrop-blur-sm">
            <span className="mr-2">🌐</span>
            <select
                id="lang"
                onChange={handleLangChange}
                value={i18n.language}
                className="appearance-none bg-gray-900 bg-opacity-70 text-white text-sm px-3 py-1 rounded-full shadow-inner border border-white/10 
             focus:outline-none focus:ring-2 focus:ring-secondary transition-all duration-300"
            >
                <option className="bg-gray-900 text-white" value="en">EN</option>
                <option className="bg-gray-900 text-white" value="es">ES</option>
            </select>


        </div>
    );
};

export default LanguageSwitcher;
